import {
  requestGet,
  requestPost,
  requestPut,
  requestDelete,
} from "../config/Api";

const base = "custom-status";

export const getCustomStatuses = (scope, params = {}) =>
  requestGet(base, { scope, ...params });

export const getCustomStatusOptions = (scope) =>
  requestGet(`${base}/options`, { scope });

export const createCustomStatus = (data) => requestPost(base, data);

export const updateCustomStatus = (id, data) =>
  requestPut(`${base}/${id}`, data);

export const disableCustomStatus = (id) => requestDelete(`${base}/${id}`);

export const enableCustomStatus = (id) => requestPost(`${base}/${id}/enable`);
